<template>
  <div class="mx-auto px-4 bg-white min-h-screen">
    <div class="px-4 pt-20 pb-20">
      <Sidebar></Sidebar>
      <Header> {{$t('all.communication')}} · {{getClassName($route)}}
        <CommunicationHeader>
          <div slot="left">
            <ul class="list-reset flex">
              <li
                class="-mb-px mr-1"
                @click="showInbox"
              >
                <div
                  :class="!show_outbox ? 'bg-white text-blue' : 'bg-blue'"
                  class="text-white inline-block py-1 px-4 hover:text-blue hover:bg-white font-semibold"
                >
                  {{$t('all.inbox')}} {{ unreadEmails() }}
                </div>
              </li>
              <li
                class="mr-1"
                @click="showOutbox"
              >
                <div
                  :class="show_outbox ? 'bg-white text-blue' : 'bg-blue'"
                  class="text-white inline-block py-1 px-4 hover:text-blue hover:bg-white font-semibold"
                >
                  {{$t('all.outbox')}}
                </div>
              </li>
            </ul>
          </div>
        </CommunicationHeader>
      </Header>
      <div class="pt-8">
        <div
          v-for="item in getData"
          :key="item.id"
        >
          <div
            class="communication-card py-2 z-30 border-b-2 border-dashed border-blue-light"
            @click="openEmail(item)"
          >
            <div class="flex py-1 justify-between">
              <h4
                class="text-blue truncate font-medium"
                :class="(!item.is_read && !show_outbox) ? 'font-bold' : ''"
              >{{getName(item)}}</h4>
              <p
                class="text-grey text-xs font-light"
                :class="(!item.is_read && !show_outbox) ? 'font-bold text-blue' : ''"
              >{{checkInboxDate(item)}}</p>
            </div>
            <p
              class="text-grey text-base py-1"
              :class="(!item.is_read && !show_outbox) ? 'font-bold' : ''"
            >{{item.subject}}</p>
            <p class="pr-10 text-sm truncate font-light">{{item.content}}</p>
          </div>
        </div>
        <div
          class="flex-row-reverse flex fixed no-underline"
          style="bottom: 90px;right: 30px;"
          @click="createCommunication"
        >
          <i class=" fas fa-pen p-3 rounded-full text-white bg-blue shadow align-middle ml-5"></i>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import { authService } from '@/services';
import { mapGetters, mapActions } from 'vuex';
import orderBy from 'lodash/orderBy';
import map from 'lodash/map';

export default {
  name: 'Communication',
  props: ['id'],
  data() {
    return {
      show_outbox: false,
      unreadEmail: null,
    };
  },
  computed: {
    ...mapGetters({
      inbox: 'communication/inbox',
      inboxCount: 'communication/inboxCount',
      outbox: 'communication/outbox',
      getClassName: 'users/getClassName',
      userInfo: 'authentication/userInfo'
    }),
    getData() {
      let data = this.inbox.items;
      if (this.show_outbox) {
        data = orderBy(this.outbox.items, ['date'], ['desc']);
      }
      return orderBy(data, ['date'], ['desc']);
    },
  },
  methods: {
    ...mapActions('communication', [
      'getTutorInbox',
      'getTeacherInbox',
      'getTutorOutbox',
      'getTeacherOutbox',
      'getTeacherCount',
      'getTutorCount'
    ]),
    ...mapActions('users', ['getMinor']),
    ...mapActions('authentication', ['getUserInfo']),
    showInbox() {
      console.log('inbox clicked');
      this.show_outbox = false;
      if (this.userInfo.role === 'tutor') {
        this.getTutorInbox({
          minorId: this.$route.params.id,
        });
      } else if (this.userInfo.role === 'teacher') {
        this.getTeacherInbox({
          classroom_id: this.$route.params.id,
        });
      }
    },
    showOutbox() {
      console.log('outbox clicked');
      this.show_outbox = true;
      if (this.userInfo.role === 'tutor') {
        this.getTutorOutbox({
          minorId: this.$route.params.id,
        });
      } else if (this.userInfo.role === 'teacher') {
        this.getTeacherOutbox({
          classroom_id: this.$route.params.id,
        });
      }
    },
    getName(item) {
      let data = '';
      if (this.userInfo.role === 'teacher') {
        if (this.show_outbox) {
          return map(
            item.minors,
            minor => `${minor.name} ${minor.surname}`,
          ).join(', ');
        }
        data = `${item.minor.name} ${item.minor.surname}`;
      } else if (this.userInfo.role === 'tutor') {
        data = `${item.institute_name} - ${item.classroom_name}`;
      }
      return data;
    },
    openEmail(item) {
      let emailId = item.id;
      if (this.show_outbox) {
        emailId = item.uuid;
      }
      this.$router.push({
        name: 'FullEmail',
        params: { id: emailId },
        query: { action: this.show_outbox ? 'Outbox' : 'Inbox' },
      });
    },
    createCommunication() {
      this.$router.push({
        name: 'CreateCommunication',
        params: { id: this.$route.params.id },
        query: { class: this.$route.query.classe },
      });
    },
    checkInboxDate(item) {
      const today = this.$moment().format('DD-MM-YYYY');
      const yesterday = this.$moment()
        .subtract(1, 'days')
        .format('DD-MM-YYYY');
      if (item.date === today) {
        return item.time;
      } else if (this.$moment(item.date).isSame(today, 'week')) {
        return `${this.$t(`all.${this.$moment(item.date, 'DD-MM-YYYY')
            .format('ddd')
            .toLowerCase()}`, )}`;
      } else if (item.date === yesterday) {
        return `${this.$t('all.yesterday')}`;
      } else if (this.$moment(item.date).isSame(today, 'year')) {
        return `${this.$moment(item.date, 'DD-MM-YYYY').format('DD')} ${this.$t(`all.${this.$moment(item.date, 'DD-MM-YYYY')
            .format('ddd')
            .toLowerCase()}`, )} ${this.$moment(item.date, 'DD-MM-YYYY').year()}`;
      }
      return `${this.$moment(item.date, 'DD-MM-YYYY').format('DD')} ${this.$t(`all.${this.$moment(item.date, 'DD-MM-YYYY')
          .format('MMMM')
          .toLowerCase()}`, )}`;
    },
    unreadEmails() {
      return this.inboxCount <= 9 ? this.inboxCount : '9+';
    }
  },
  async created() {
    await this.getUserInfo();
    if (this.userInfo.role === 'tutor') {
      await this.getMinor({
        id: this.id,
        role: this.userInfo.role,
      });
      this.getTutorInbox({ minorId: this.id });
      this.getTutorCount({ minorId: this.id });
    } else if (this.userInfo.role === 'teacher') {
      this.getTeacherCount({
        classroomId: this.id,
      });
      this.getTeacherInbox({
        classroom_id: this.id,
      });
    }
  },
};
</script>
